import 'Components/AppComponents/PointBar/PointBar.css';

type PointBarProps = {
    currentCleanEnergyPercentage: number;
    isLeft?: boolean;
};

const PointBar = ({ currentCleanEnergyPercentage, isLeft = true }: PointBarProps) => {
    // usePointBarAnimation({currentCleanEnergyPercentage, isLeft});
    
    return (
        <>
            <div className={`flex flex-row justify-between pointBar p-4 relative`}>
                <div id={isLeft ? '1-peak-load' : '0-peak-load'} className="dimensions z-20 dirty-color" style={{ background: `url(/images/PowerRangeDirtyEnergy.png) no-repeat center`, backgroundSize: 'contain', paddingLeft: '88px', paddingBottom: '70px' }}>
                    
                </div>

                <div className="my-auto w-full h-16  flex"
                    style={{
                        backgroundColor: 'rgb(0,0,0,0.2)',
                        padding: '0 25px',
                        marginLeft: '-43.6px',
                        marginRight: '-49px'
                    }}
                >
                    <div
                        id={isLeft ? '1-point-bar' : '0-point-bar'}
                        className="bar my-auto h-4/5 w-full flex justify-around duration-1000"
                        style={{
                            background: `linear-gradient(90deg, rgba(255,0,0,0.7) 45%, rgba(0,184,255,0.9) 55%)`, //rgba(0,173,233,1)
                            backgroundSize: '215%',
                        }}
                    >
                        {[...new Array(9)].map((product, index) => (
                            <div key={index} className="w-0.5" style={{ backgroundColor: '#0B9443' }}></div>
                        ))}
                    </div>
                </div>

                <div id={isLeft ? '1-clean' : '0-clean'} className="dimensions z-20 clean-color" style={{ background: `url(/images/PowerRangeCleanEnergy.png) no-repeat center`, backgroundSize: 'contain', paddingBottom: '69px', paddingLeft: '69px' }}>
                </div>
            </div>
        </>
    );
};

export default PointBar;
